const SettingApi = {
    putUpdate: '/crud/settings/:id',
    getId: '/crud/settings/:id',
}

export default SettingApi;
